import { environment } from '../../../environments/environment';
import { GenericServices } from 'max-ng-lib';
import { take, finalize, catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import {Observable} from "rxjs";

export abstract class GenericRoteirizadorService extends GenericServices {

  protected constructor() {
    super();
  }

  getBaseURL(): string {
    return environment.BASE_URL;
  }

  protected gerarRelatorioRomaneio(url, params) {
    this.disparaLoading(true);
    return this.getHttpClient().get(`${this.getBaseURL()}${url}`, {
      params,
      responseType: 'blob'
    }).pipe(
      take(1),
      finalize(this.removerLoading.bind(this, true)),
      catchError(async (error: HttpErrorResponse) => {
        const result = await this.parseErrorBlob(error);
        return this.tratarErro(result, true, 'Erro ao gerar relatório');
      })
    );
  }

  protected gerarRelatorioPost(url, body) {
    this.disparaLoading(true);
    return this.getHttpClient()
      .post(`${this.getBaseURL()}${url}`, body, {
        responseType: 'blob'
      })
      .pipe(
        take(1),
        finalize(this.removerLoading.bind(this, true)),
        catchError(async (error: HttpErrorResponse) => {
          if (error && error.error instanceof Blob) {
            const errorJson = await this.parseErrorBlob(error);
            return this.tratarErro(errorJson, true, 'Erro ao gerar relatório');
          }
          return this.tratarErro(error, true, 'Erro ao gerar relatório');
        })
      );
  }

  exportarRealtorio(result, nomeRelatorio) {
    const url = window.URL.createObjectURL(result);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = nomeRelatorio;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  parseErrorBlob(err: HttpErrorResponse): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
          if (typeof reader.result === 'string') {
            const error = JSON.parse(reader.result);
            resolve(error.erros[0].message);
          } else {
            resolve(err);
          }
        };
        reader.readAsText(err.error);
      } catch (err) {
        return resolve('Erro ao gerar relatório!');
      }
    });
  }

  gerarRelatorioBody(url, params) {
    this.disparaLoading(true);
    return this.getHttpClient().post(`${this.getBaseURL()}${url}`, params,
      {responseType: 'blob'})
      .pipe(
        take(1),
        finalize(this.removerLoading.bind(this, true)),
        catchError((err) => {
          if (
            err.error instanceof Blob &&
            err.error.type === 'application/json'
          ) {
            return new Promise<any>((resolve, reject) => {
              let reader = new FileReader();
              reader.onload = (e: Event) => {
                try {
                  const errmsg = JSON.parse(
                    (<any>e.target).result
                  );
                  reject(
                    this.tratarErro(
                      errmsg.erros[0],
                      true,
                      'Erro ao gerar relatório'
                    )
                  );
                } catch (e) {
                  reject(err);
                }
              };
              reader.onerror = (e) => {
                reject(err);
              };
              reader.readAsText(err.error);
            });
          }
          return this.tratarErro(
            err,
            true,
            'Erro ao gerar relatório'
          );
        })
      );
  }

  /* O código abaixo é para imprimir o traceId em caso de erro na requisição no console.log
* infelizmente usamos essa lib compilada da maxima que intercepta o erro e já joga num msgService
* impedindo de colocar o console.log lá dentro. Futuramente pretendo migrar essa lib para dentro do projeto
* porém até lá, estou fazendo override dos get,post,delete,put para que seja incluido o console.log
*/

  get<T>(servico: string, options: any = {}): Observable<T> {
    return super.get<T>(servico, options).pipe(
      catchError((err) => {
        if (err.error) {
          console.log('Api trace erro:', err.error.traceApiId);
        }
        throw err;
      })
    );
  }


  post<T>(servico: string, options: any = {}): Observable<T> {
    return super.post<T>(servico, options).pipe(
      catchError((err) => {
        if (err.error) {
          console.log('Api trace erro:', err.error.traceApiId);
        }
        throw err;
      })
    );
  }

  put<T>(servico: string, options: any = {}): Observable<T> {
    return super.put<T>(servico, options).pipe(
      catchError((err) => {
        if (err.error && err.error.erros && err.error.erros.length > 0) {
          console.log('Api trace erro:', err.error.traceApiId);
        }
        throw err;
      })
    );
  }

  delete(servico: string, options: any = {}): Observable<any> {
    return super.delete(servico, options).pipe(
      catchError((err) => {
        if (err.error) {
          console.log('Api trace erro:', err.error.traceApiId);
        }
        throw err;
      })
    );
  }


}
